import React, { useState, useMemo, useEffect } from 'react';
import { Amplify } from "aws-amplify";
import { Box, Grid, Typography } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import CssBaseline from "@mui/material/CssBaseline";
import Layout from "./components/layout/Layout";
import awsExports from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";
import logo from "./assets/images/RWIdataLab_logo.jpg";
import { LicenseInfo } from '@mui/x-license';
import { store } from './store';
import { Provider } from 'react-redux';
import { ReactComponent as LoginImage } from './assets/images/login.svg';
import { Auth } from 'aws-amplify';
import { ThemeProvider } from './features/theme/ThemeProvider';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

Amplify.configure(awsExports);

const components = {
  Header() {
    return (
      <Box
        component="div"
        sx={{
          textAlign: 'center',
          padding: 2,
          backgroundColor: 'white',
          borderRadius: '12px'
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <img src={logo} alt="logo" style={{
            maxWidth: '50%'
          }} />
          {/* <LoginImage height={'100%'} width={'100%'} /> */}
        </div>
      </Box>
    );
  },
  // Footer() {
  //   return (
  //     <Box
  //       component="div"
  //       textAlign="center"
  //       padding={2}
  //       bgcolor={primaryColor}
  //       color="white"
  //     >
  //       <Typography>&copy; All Rights Reserved</Typography>
  //     </Box>
  //   );
  // },
};

function App() {
  const [mode, setMode] = useState("light");
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode]
  );

  return (
    <Box className={'login-root-box'}>
      {/* {authStatus !== 'authenticated' && <Box sx={{
        maxWidth: '800px',
        backgroundColor: 'white',
        borderRadius: '12px 12px 0px 0px',
        padding: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center'
      }}>
        <img src={logo} alt="logo" style={{
          maxWidth: '60%'
        }} />
      </Box>} */}
      <Authenticator
        hideSignUp
        components={components}
      >
        {({ signOut, user }) => (
          <Provider store={store}>
            <ThemeProvider theme={theme}>
              <Router>
                <CssBaseline />
                <Layout user={user} signOut={signOut} />
              </Router>
            </ThemeProvider>
          </Provider>
        )}
      </Authenticator>
    </Box>
  );
}

export default App;
